import { CartDetail } from "src/types"
import { assertValid } from "./bundled-discount-validate"

export default (cartDetail: CartDetail) => {
  assertValid(cartDetail)

  return {
    items: cartDetail.items.map(cartItem => {
      return {
        id: Number(cartItem.variantId),
        quantity: cartItem.quantity ? cartItem.quantity : 1,
        properties: {
          _nosto_bundle: {
            bundle_products: cartDetail.bundleProducts.map(item => Number(item)),
            discount: {
              type: cartDetail.discount.type,
              value: cartDetail.discount.value
            },
            _hash: cartDetail.hash
          }
        }
      }
    })
  }
}
